import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from '../../api/api';

import { confirmDialog } from "../../components/em/confirm";
const MasterDataManagement = () => {
  
  const baseURL =  `${API_URL}/api/settings`;

  const [departments, setDepartments] = useState([]);
  const [employmentTypes, setEmploymentTypes] = useState([]);
  const [jobTitles, setJobTitles] = useState([]);
  const [employmentStatuses, setEmploymentStatuses] = useState([]);
  const [workLocations, setWorkLocations] = useState([]);


  const [newDept, setNewDept] = useState("");
  const [newType, setNewType] = useState("");
  const [newJobTitle, setNewJobTitle] = useState("");
  const [newEmployeeStatus, setNewEmployeeStatus] = useState("");
  const [newWorkLocation, setNewWorkLocation] = useState("");

  const [editRow, setEditRow] = useState({ type: "", id: null, value: "" });

  useEffect(() => {
    fetchDepartments();
    fetchEmploymentTypes();
    fetchJobTitles();
    fetchEmploymentStatuses();
    fetchWorkLocations();

  }, []);

  const fetchDepartments = async () => {
    try {
      const res = await axios.get(`${baseURL}/departments`);
      setDepartments(res.data || []);
    } catch (err) {
      console.error("Error fetching departments", err);
      setDepartments([]);
    }
  };

  const fetchEmploymentTypes = async () => {
    try {
      const res = await axios.get(`${baseURL}/employment-types`);
      setEmploymentTypes(res.data || []);
    } catch (err) {
      console.error("Error fetching employment types", err);
      setEmploymentTypes([]);
    }
  };

  const fetchJobTitles = async () => {
    try {
      const res = await axios.get(`${baseURL}/job-titles`);
      setJobTitles(res.data || []);
    } catch (err) {
      console.error("Error fetching job titles", err);
      setJobTitles([]);
    }
  };
  const fetchEmploymentStatuses = async () => {
    try {
      const res = await axios.get(`${baseURL}/employment-statuses`);
      setEmploymentStatuses(res.data || []);
    } catch (err) {
      console.error("Error fetching EmploymentStatus", err);
      setEmploymentStatuses([]);
    }
  };
   const fetchWorkLocations = async () => {
    try {
      const res = await axios.get(`${baseURL}/work-locations`);
      setWorkLocations(res.data || []);
    } catch (err) {
      console.error("Error fetching work locations", err);
      setWorkLocations([]);

    }
  };
  const handleAdd = async (type) => {
    try {
      if (type === "departments" && newDept.trim()) {
        await axios.post(`${baseURL}/departments`, { name: newDept });
        setNewDept("");
        fetchDepartments();
      } else if (type === "employmentTypes" && newType.trim()) {
        await axios.post(`${baseURL}/employment-types`, { name: newType });
        setNewType("");
        fetchEmploymentTypes();
      } else if (type === "jobTitles" && newJobTitle.trim()) {
        await axios.post(`${baseURL}/job-titles`, { name: newJobTitle });
        setNewJobTitle("");
        fetchJobTitles();
      }
      else if (type === "employmentStatuses" && newEmployeeStatus.trim()) {
        await axios.post(`${baseURL}/employment-statuses`, { name: newEmployeeStatus });
        setNewEmployeeStatus("");
        fetchEmploymentStatuses();
      }
       else if (type === "workLocations" && newWorkLocation.trim()) {
        await axios.post(`${baseURL}/work-locations`, { name: newWorkLocation });
       setNewWorkLocation("");
        fetchWorkLocations();
      }
    } catch (err) {
      console.error("Error adding item", err);
    }
  };

  const handleEdit = (type, id, value) => {
    setEditRow({ type, id, value });
  };

  const handleSave = async () => {
    const { type, id, value } = editRow;
    try {
      if (type === "departments") {
        await axios.put(`${baseURL}/departments/${id}`, { name: value });
        fetchDepartments();
      } else if (type === "employmentTypes") {
        await axios.put(`${baseURL}/employment-types/${id}`, { name: value });
        fetchEmploymentTypes();
      } else if (type === "jobTitles") {
        await axios.put(`${baseURL}/job-titles/${id}`, { name: value });
        fetchJobTitles();
      }
      else if (type === "employmentStatuses") {
        await axios.put(`${baseURL}/employment-statuses/${id}`, { name: value });
        fetchEmploymentStatuses();
      }
      else if (type === "workLocations") {
        await axios.put(`${baseURL}/work-locations/${id}`, { name: value });
        fetchWorkLocations();
      }
      setEditRow({ type: "", id: null, value: "" });
    } catch (err) {
      console.error("Error saving", err);
    }
  };

  const handleDelete = async (type, id) => {
    if (!(await confirmDialog("Delete this item?"))) return;
    try {
      if (type === "departments") {
        await axios.delete(`${baseURL}/departments/${id}`);
        fetchDepartments();
      } else if (type === "employmentTypes") {
        await axios.delete(`${baseURL}/employment-types/${id}`);
        fetchEmploymentTypes();
      } else if (type === "jobTitles") {
        await axios.delete(`${baseURL}/job-titles/${id}`);
        fetchJobTitles();
      }
      else if (type === "employmentStatuses") {
        await axios.delete(`${baseURL}/employment-statuses/${id}`);
        fetchEmploymentStatuses();
      }
       else if (type === "workLocations") {
        await axios.delete(`${baseURL}/work-locations/${id}`);
        fetchWorkLocations();
      }
    } catch (err) {
      console.error("Error deleting", err);
    }
  };

  const renderCard = (
    title,
    description,
    items,
    newValue,
    setNewValue,
    type,
    placeholder
  ) => (
    <div className="data-card">
      <div className="card-header">
        <h3>{title}</h3>
        <p className="desc">{description}</p>
      </div>

      <div className="add-row">
        <input
          value={newValue}
          onChange={(e) => setNewValue(e.target.value)}
          placeholder={placeholder}
        />
        <button onClick={() => handleAdd(type)}>+</button>
      </div>

      <div className="list">
        {!Array.isArray(items) || items.length === 0 ? (
          <p className="empty-text">No {title.toLowerCase()} added yet</p>
        ) : (
          <ul>
            {items.map((item) => (
              <li key={item.id}>
                {editRow.id === item.id && editRow.type === type ? (
                  <>
                    <input
                      value={editRow.value}
                      onChange={(e) =>
                        setEditRow({ ...editRow, value: e.target.value })
                      }
                      onKeyDown={(e) => {
                        if (e.key === "Enter") handleSave();
                        if (e.key === "Escape")
                          setEditRow({ type: "", id: null, value: "" });
                      }}
                    />
                    <button className="save" onClick={handleSave}>
                      Save
                    </button>
                  </>
                ) : (
                  <>
                    <span>{item.name}</span>
                    <div className="actions">
                      <button
                        className="edit"
                        onClick={() => handleEdit(type, item.id, item.name)}
                      >
                        ✎
                      </button>
                      <button
                        className="delete"
                        onClick={() => handleDelete(type, item.id)}
                      >
                        ✕
                      </button>
                    </div>
                  </>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>

      <div className="footer">
        {Array.isArray(items) ? items.length : 0} {title.toLowerCase()} configured
      </div>
    </div>
  );

  return (
    <div className="master-layout">
      <h2 className="main-title">Master Data Management</h2>
      <p className="subtitle">
        Manage centralized employee data options
      </p>

      <div className="card-grid">
        {renderCard(
          "Departments",
          "Organization departments and teams",
          departments,
          newDept,
          setNewDept,
          "departments",
          "Add new department..."
        )}
        {renderCard(
          "Employment Types",
          "Employment categories and classifications",
          employmentTypes,
          newType,
          setNewType,
          "employmentTypes",
          "Add new employment type..."
        )}
        {renderCard(
          "Job Titles",
          "Employee positions and designations",
          jobTitles,
          newJobTitle,
          setNewJobTitle,
          "jobTitles",
          "Add new job title..."
        )}
        {renderCard(
          "Employee Statuses",
          "Employee status options",
          employmentStatuses,
          newEmployeeStatus,
          setNewEmployeeStatus,
          "employmentStatuses",
          "Add new employe Statuses..."
        )}
        {renderCard(
          "Work Locations",
          "Office locations and work sites",
          workLocations,
          newWorkLocation,
          setNewWorkLocation,
          "workLocations",
          "Add new work locations..."
        )}
      </div>
    </div>
  );
};

export default MasterDataManagement;
